import React, { useState } from 'react';

const CategoryModal = ({ type, isOpen, onClose, onSubmit, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    name_ky: '',
    description: '',
    description_ky: '',
    color: '#2563eb',
    icon: ''
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    // Reset form after submit managed by parent or here? 
    // Usually parent handles success then closes. 
    // We can clear form on close or effect.
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <h3>Добавить категорию {type === 'newsCategory' ? 'новостей' : 'книг'}</h3>
          
          <div className="form-group">
            <label>Название *</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Русский"
            />
             <input
              type="text"
              name="name_ky"
              value={formData.name_ky}
              onChange={handleChange}
              placeholder="Кыргызча"
              style={{ marginTop: '5px' }}
            />
          </div>

          <div className="form-group">
            <label>Описание</label>
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              rows="2"
              placeholder="Русский"
            />
             <textarea
              name="description_ky"
              value={formData.description_ky}
              onChange={handleChange}
              rows="2"
              placeholder="Кыргызча"
              style={{ marginTop: '5px' }}
            />
          </div>

          {type === 'newsCategory' && (
            <>
              <div className="form-group">
                <label>Цвет</label>
                <input
                  type="color"
                  value={formData.color}
                  onChange={(e) => setFormData({ ...formData, color: e.target.value })}
                />
              </div>

              <div className="form-group">
                <label>Иконка</label>
                <input
                  type="text"
                  value={formData.icon}
                  onChange={(e) => setFormData({ ...formData, icon: e.target.value })}
                  placeholder="newspaper, politics, sport"
                />
              </div>
            </>
          )}

          <div className="modal-actions">
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? 'Создание...' : 'Создать категорию'}
            </button>
            <button type="button" className="cancel-button" onClick={onClose}>
              Отмена
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CategoryModal;
